var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9 21h5v8l-2.534-2L9 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M17 21h5v8l-2.534-2L17 29z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(20 11.5 25)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M9.5 21.5v6.45l1.962-1.59 2.038 1.608V21.5h-4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(20 0 -85.59)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M17.5 21.5v6.45l1.962-1.59 2.038 1.608V21.5h-4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 1.3,
    d: "M22.526 19.335c0-1.217.708-2.899 1.57-3.762a2.204 2.204 0 0 0 0-3.12c-.862-.863-1.57-2.545-1.57-3.762a2.22 2.22 0 0 0-2.213-2.213c-1.217 0-2.9-.708-3.762-1.57-.841-.864-2.257-.864-3.12 0-.863.862-2.545 1.57-3.762 1.57a2.22 2.22 0 0 0-2.213 2.213c0 1.217-.708 2.9-1.571 3.762-.841.841-.841 2.257.022 3.12s1.57 2.545 1.57 3.762a2.22 2.22 0 0 0 2.214 2.213c1.217 0 2.899.708 3.762 1.571a2.204 2.204 0 0 0 3.12 0c.863-.863 2.545-1.57 3.762-1.57a2.215 2.215 0 0 0 2.19-2.214z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.137 14.874l2.247 2.238L18 11.118"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.5c5a66672e71d7b2d00f6ac60b1eda4f.svg";
export { ForwardRef as ReactComponent };